import { Field } from "~/components/job/BlockFieldsModal";
import { JobStates } from "~/components/build/Show/lib/types/JobStates";
import { BaseJob } from "~/components/build/Show/lib/types/BaseJob";
import { Job } from "~/components/build/Show/lib/types/Job";

export function isInputJob(job: Job): job is InputJob {
  return job.type === "manual";
}

// We use job.unblockedAt and job.unblockedBy to determine if the job is unblocked,
// rather than job.state, because job.state will remain 'blocked' until the pipeline has processed
// all prior steps, even if the step has been unblocked.
// Therefore, using unblockedAt and unblockedBy is more reliable.
export function isInputJobUnblocked(job: InputJob): job is UnblockedInputJob {
  return job.unblockedAt !== undefined && job.unblockedBy !== undefined;
}

export const isInputNodeDisabled = (job: InputJob) => {
  return job.state === "blocked_failed" || job.state === "broken" || job.state === "canceled";
};

export interface UnblockedInputJob extends InputJob {
  unblockedAt: string;
  unblockedBy: { name: string; avatarUrl: string };
}

export interface InputJob extends BaseJob {
  type: "manual";
  id: string;
  unblockDialogPath: string;
  unblockPath: string;
  fields: Array<Field>;
  name: string | null | undefined;
  permissions: {
    activate: {
      allowed: boolean;
      message?: string;
    };
  };
  step?: {
    label: string | null | undefined;
  };
  prompt: string | null | undefined;
  state: JobStates;
  submit: string | null | undefined;
  tooltip?: string;
  groupUuid: string | null | undefined;
  groupLabel: string | null | undefined;
  groupIdentifier: string | null | undefined;
  stepUuid: string;
  triggerProject?: {
    name: string;
  };
  unblockedAt?: string;
  unblockedBy?: {
    name: string;
    avatarUrl: string;
  };
  softFailed?: boolean;
  path: string;
}
